import { render, staticRenderFns } from "./DeleteMultipleDocuments.vue?vue&type=template&id=56c318b0&scoped=true"
import script from "./DeleteMultipleDocuments.vue?vue&type=script&lang=js"
export * from "./DeleteMultipleDocuments.vue?vue&type=script&lang=js"
import style0 from "./DeleteMultipleDocuments.vue?vue&type=style&index=0&id=56c318b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c318b0",
  null
  
)

export default component.exports